/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiLink } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { AnyAdminProject } from '@modules/project-admin-api/types'
import type { ProjectID } from '@modules/ui-types/projects'

// eslint-disable-next-line import/no-restricted-paths
import { getConfigForKey } from '@/store'

const QUERIES = {
  proxyLogs: {
    title: (
      <FormattedMessage
        id='project.link.serverless-proxy-logs'
        defaultMessage='Project proxy logs'
      />
    ),
    index: 'serverless-logging-*:logs-proxy.log-*',
    makeQuery: (projectId: ProjectID) =>
      `(data_stream.dataset: "proxy.log") AND (log.logger: request OR log.logger: requestError) AND (serverless.project.id: ${projectId})`,
  },
}

export type Props = {
  project: AnyAdminProject
  query: keyof typeof QUERIES
}

const ObservabilityDiscoverLink: React.FunctionComponent<Props> = ({ project, query }) => {
  const o11yDomain = getConfigForKey(`CLOUD_SERVERLESS_O11Y_DOMAIN`)

  if (!o11yDomain) {
    return null
  }

  const { title, index, makeQuery } = QUERIES[query]

  const url = `https://${o11yDomain}/app/discover#/?_g=(time:(from:now-2h,to:now))&_a=(index:'${index}',query:(language:lucene,query:'${makeQuery(
    project.id,
  )}'))`

  return (
    <EuiLink external={true} href={url} target='_blank'>
      {title}
    </EuiLink>
  )
}

export default ObservabilityDiscoverLink
